<script lang="ts">
import { POWERED_BY_SS_PATH, SMARTSUPP_URL, WEB_SUPPORTED_LANGUAGES } from '@/constants'
import { widgetOptions } from '@/modules/options'
import { type AppLocale, locale } from '@/modules/translations'
import type { SmartsuppPackage } from '@/types'
import { getHostWindow } from '@/utils/window'

import BrandingLink from './WidgetBrandingLink.svelte'
import BrandingText from './WidgetBrandingText.svelte'

const { packageName } = widgetOptions.getOptions()

const locationHost = getHostWindow().location.host || ''
const locationHostname = getHostWindow().location.hostname || ''
let packageNameParam: SmartsuppPackage = packageName === 'trial' ? 'pro' : packageName
const isWebSupportedLanguage = (lang: AppLocale) => WEB_SUPPORTED_LANGUAGES.includes(lang)
const getSupportedLang = (lang: AppLocale) => {
	if (isWebSupportedLanguage(lang)) return `/${lang}`
	return ''
}
</script>

<BrandingLink
	url={`${SMARTSUPP_URL}${getSupportedLang(
		$locale,
	)}${POWERED_BY_SS_PATH}/?utm_source=chat-widget-${packageNameParam}&utm_medium=chat-widget&utm_campaign=${locationHost}&domain=${locationHostname}`}
>
	<BrandingText>Powered by Smartsupp</BrandingText>
</BrandingLink>
